import React, { FC, useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import { useDispatch, useSelector } from 'react-redux'
import { ISfBankAccount } from '@sparling/financial-common'
import { GreenButton } from '../../../../components/Buttons/GreenButton'
import { IDataItem, TableComponent } from '../../../../components/Table'
import { icons } from '../../../../constants/icons'
import { columns } from './BankAccountsList'
import { sfBankAccountsIsLoading, getSfBankAccountsData } from '../../../../store/selectors'
import { getSfBankAccountsRequest } from '../../../../store/actions'
import { BankAccountsModal } from './BankAccountsModal'
import { BankAccountsFilters } from './BankAccountsFilters'

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    justifyContent: 'space-between',
    backgroundColor: 'rgba(255, 255, 255, 0.05)',
    marginTop: theme.spacing(2),
    padding: theme.spacing(4),
    height: '100%',
  },
  titleWrap: {
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    minWidth: 400,
  },
  table: {
    paddingTop: theme.spacing(2),
  },
  buttonWrap: {
    justifyContent: 'flex-end',
  },
}))

export const BankAccounts: FC = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const accountsIsLoading = useSelector(sfBankAccountsIsLoading)
  const { items, meta } = useSelector(getSfBankAccountsData)
  const [isOpenAccountModal, setOpenAccountModal] = useState<boolean>(false)
  const [selectedAccountId, setSelectedAccountId] = useState<number | null>(null)

  const loadAccountsData = useCallback(
    (page = 1) => {
      dispatch(
        getSfBankAccountsRequest({
          page,
        }),
      )
    },
    [dispatch],
  )

  useEffect(() => {
    loadAccountsData()
  }, [loadAccountsData])

  const getSelectedElementIdHandle = useCallback((id) => {
    setSelectedAccountId(id)
  }, [])

  const addBankAccountModalHandle = useCallback(() => {
    setOpenAccountModal(true)
    setSelectedAccountId(null)
  }, [])

  const editBankAccountModalHandle = useCallback((id: string | number) => {
    setSelectedAccountId(Number(id))
    setOpenAccountModal(true)
  }, [])

  const closeBankAccountModalHandle = useCallback(() => setOpenAccountModal(false), [])

  return (
    <>
      <Grid container className={classes.container}>
        <Grid container className={classes.titleWrap}>
          <Grid item xs={10} display="flex">
            <BankAccountsFilters />
          </Grid>
          <Grid item xs={2} display="flex" justifyContent={'flex-end'}>
            <GreenButton
              width={140}
              prefix={icons.ADD}
              ml={8}
              text={'Add Account'}
              onClick={addBankAccountModalHandle}
            />
          </Grid>
        </Grid>
        <Grid container className={classes.table}>
          <TableComponent
            getElementId={getSelectedElementIdHandle}
            columns={columns}
            data={items as IDataItem<ISfBankAccount>[]}
            params={meta}
            isShowEditIcon={true}
            isShowInfoIcon={false}
            onEdit={editBankAccountModalHandle}
            loading={accountsIsLoading}
            loadData={loadAccountsData}
          ></TableComponent>
        </Grid>
      </Grid>
      {isOpenAccountModal && (
        <BankAccountsModal
          isOpen={true}
          modalClose={closeBankAccountModalHandle}
          fields={items.find((item) => item.id === selectedAccountId) as ISfBankAccount}
        />
      )}
    </>
  )
}
